import { Paper } from "@mui/material"
import { DataGrid } from "@mui/x-data-grid";
import { useState, useEffect } from "react";
import {useNavigate} from 'react-router-dom'

import moment from 'moment'
import useFetch from './api/api'
import config from "./common/Config";

const Notifications = () => {

	const navigate = useNavigate()
	const [notifications, setNotifications] = useState();
	const privateFetch = useFetch();

	useEffect(() => {
		privateFetch(config.apiUrl +'/api/notifications/all')
		.then(data => data.json())
		.then(data => setNotifications(data))
	}, [])

	if ( notifications === undefined) {
		return
	}

	const handleRowClick = (params) => {
		let index = notifications.findIndex(n => n.id === params.row.id)
		notifications[index].status = 'READ'
		
		privateFetch(config.apiUrl +'/api/notifications/read/'+ params.row.id)

		setNotifications(notifications)
		navigate(notifications[index].link)
	}

	const columns = [
		{	
			field : 'date', 
			headerName : 'Data',
			valueFormatter : (params) => moment(params).format("DD/MM/YYYY"),
			disableColumnMenu : true
		},
		{field : 'message', headerName : 'Notificação', width: 600, sortable : false, disableColumnMenu : true}
	]

	return (
		<Paper sx={{marginLeft: 2, marginRight: 4}}>
			<DataGrid 
				columns={columns}
				rows={notifications}
				getRowClassName={(params) => params.row.status === 'UNREAD' ? "unread" : ""}
				sx={{
					".unread" : {
						fontWeight : 'bold'
					}
				}}
				onRowClick={handleRowClick}
			/>
		</Paper>
	)
}

export default Notifications